import { required, minLength, minValue, maxValue } from 'vuelidate/lib/validators'

import PubIdent from './PubIdent'
import requiredIf from 'vuelidate/lib/validators/requiredIf'

const nonNullBoolean = to => to === true || to === false

export default () => {
  let maxYear = new Date().getFullYear() || 2025

  return {
    organisationseinheit: {
      name: { required, minLength: minLength(1) }
    },
    // weitereOrganisationseinheiten: {
    //  name: {required: requiredIf((resourceDate) => resourceDate.relevantFuerWeitere === true)
    //  }
    // },
    titelPublikation: { required, minLength: minLength(1) },
    publikationsTyp: { required },
    veroeffentlichungsJahr: { required, minValue: minValue(1409), maxValue: maxValue(maxYear) },
    // titelPublikation: {
    //  required: requiredIf((PubIdent) => PubIdent.Wert == null || PubIdent.Wert.lenght === 0)
    // },
    pubIdent: {
      $each: PubIdent
    },
    author: {
      required: requiredIf((resourceData) => {
        return ['ARTIKEL', 'SAMMELBANDBEITRAG', 'TAGUNGSBEITRAG', 'BUCHBEITRAG', 'MONOGRAPHIE',
          'BERICHT', 'WORKINGPAPER', 'BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN', 'DISSERTATION',
          'HABILITATIONSSCHRIFT', 'SONSTIGE']
          .includes(resourceData.publikationsTyp)
      })
    },
    inProjekt: { nonNullBoolean },
    herausgeber: {
      required: requiredIf((resourceData) => {
        return ['SAMMELBAND', 'TAGUNGSBAND', 'SONDERHEFT', 'QUELLENEDITION']
          .includes(resourceData.publikationsTyp)
      })
    },
    publicPubIdent: {
      $each: PubIdent
    },
    forschungsprojekt: {
      required: requiredIf((resourceData) => resourceData.inProjekt === true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/validation/Publikation.js